import axios from 'axios';
// import bugsnagErrorLogger from './bugsnagErrorHandler';
import urls from './config';
import {
  getLocalAccessToken,
  getLocalRefreshToken,
  getLocalUser,
  setLocalAccessToken,
  logout,
} from './helpers';

const fetch = (options) => {
  const { method = 'get', data, url, responseType } = options;

  const authToken = getLocalAccessToken();
  // eslint-disable-next-line no-unused-expressions
  authToken &&
    (axios.defaults.headers.common.Authorization = `Bearer ${authToken}`);

  switch (method.toLowerCase()) {
    case 'get':
      return axios.get(url, {
        params: data,
        responseType,
      });
    case 'delete':
      return axios.delete(url, {
        data,
      });
    case 'post':
      switch (options.upload) {
        case true:
          return axios.post(url, options.formData, options.config);
        default:
          return axios.post(url, data, { responseType });
      }
    case 'put':
      return axios.put(url, data);
    case 'patch':
      return axios.patch(url, data);
    case 'download':
      return axios.get(url, {
        params: data,
        responseType,
      });
    default:
      return axios(options);
  }
};

export default function request(options) {
  return fetch(options)
    .then((response) => {
      const { data, status } = response;
      return {
        success: true,
        raw: data,
        statusCode: status,
      };
    })
    .catch((err) => {
      const { response } = err;
      let msg;
      let statusCode;
      if (response && response instanceof Object) {
        const { data, statusText } = response;
        statusCode = response.status;

        msg =
          (typeof data === 'string' ? data : data?.error || data?.message) ||
          statusText;

        if (statusCode === 401 && !options._retried) {
          const refresh_token = getLocalRefreshToken();
          let userDetails = null;
          try {
            const rawUser = getLocalUser();
            userDetails = rawUser ? JSON.parse(rawUser) : null;
          } catch (e) {
            userDetails = null;
          }

          if (!userDetails || !refresh_token) {
            return { success: false, statusCode, message: msg };
          }

          const payload = {
            grant_type: 'refresh_grant',
            refresh_token,
            client_secret: userDetails.secret,
            client_id: userDetails.id,
          };

          const encodeFormData = (form) =>
            Object.keys(form)
              .map(
                (key) =>
                  `${encodeURIComponent(key)}=${encodeURIComponent(form[key])}`
              )
              .join('&');

          return axios
            .post(
              `${urls.UMS_BASE_URL}/oauth2/token`,
              encodeFormData(payload),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  Authorization: 'Bearer',
                },
              }
            )
            .then((resp) => {
              const refreshData = resp.data ? resp.data : {};
              if (!refreshData.access_token) {
                return { success: false, statusCode: 401, message: msg };
              }
              setLocalAccessToken(refreshData.access_token);
              // Retry once only — avoids infinite 401↔refresh loops against local API
              return request({ ...options, _retried: true });
            })
            .catch((error) => {
              const errResponse = error?.response;
              const errStatus = errResponse?.status;
              if (errStatus === 401 || errStatus === 404) {
                logout();
                return { success: false, statusCode: errStatus, message: msg };
              }
              return {
                success: false,
                statusCode: errStatus || 600,
                message: errResponse?.data?.message || errResponse?.statusText || msg,
              };
            });
        }
      } else {
        statusCode = 600;
        msg = 'Error 600: Poor internet connections.';
      }
      return { success: false, statusCode, message: msg };
    });
}
